import { atom, selector } from 'recoil'

export const checkAccountState = atom({
  key: 'checkAccountState',
  default: [],
})
